import { createSelector } from 'reselect';
import { performanceChartSelector } from './simple-selectors';

export const performanceChartDataSelector = createSelector(
    performanceChartSelector,
    (performanceChart) => performanceChart.data
);
